import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { TradeState } from '../../../../_shared/types/trade';
import Disclaimer from '../../../../_shared/components/Disclaimer';
import BiddingStatus, { BiddingStatusFloorPrice } from './BiddingStatus';

import Preview from './Preview';
import {
  StyledBidHistory,
  StyledBidHistoryPreview,
  StyledLoadingState,
  StyledPendingHistoryReport
} from './Styles';

const propTypes = {
  showHistoryPreview: PropTypes.bool,
  floorPrice: PropTypes.object,
  variant: PropTypes.oneOf(['modal', 'overview'])
};

const defaultProps = {
  showHistoryPreview: true,
  floorPrice: undefined,
  variant: undefined
};

const History = ({
  isLoading,
  variant,
  showHistoryPreview,
  bidContext,
  floorPrice,
  testId
}) => {
  const { mediaCounts, numberOfBids, tradeState } = bidContext ?? {};

  if (isLoading) {
    return (
      <StyledBidHistory viewVariant={variant} data-testid={testId}>
        <StyledLoadingState />
      </StyledBidHistory>
    );
  }

  switch (tradeState) {
    case TradeState.active:
    case TradeState.closing:
      return (
        <StyledBidHistory data-testid={testId} viewVariant={variant}>
          {showHistoryPreview && (
            <>
              <StyledBidHistoryPreview.Wrapper variant={variant}>
                <StyledBidHistoryPreview variant={variant}>
                  {Number.isInteger(numberOfBids) && (
                    <Preview variant={variant} bidContext={bidContext} />
                  )}
                </StyledBidHistoryPreview>
              </StyledBidHistoryPreview.Wrapper>
              <StyledBidHistoryPreview.Shadow variant={variant} />
            </>
          )}

          <BiddingStatus
            variant={variant}
            bidContext={bidContext}
            floorPrice={floorPrice}
          />
        </StyledBidHistory>
      );
    default:
      return (
        <>
          <StyledBidHistory
            stateVariant="upcoming"
            viewVariant={variant}
            data-testid={testId}
          >
            {!mediaCounts?.vehicleHistoryReportUrl && (
              <StyledPendingHistoryReport>
                <Disclaimer>
                  {/* The history report for this vehicle is still pending. */}
                  <FormattedMessage id="vdp.bid.pendingVHR" />
                </Disclaimer>
              </StyledPendingHistoryReport>
            )}
          </StyledBidHistory>
          <BiddingStatusFloorPrice
            floorPriceVariant="upcoming"
            floorPrice={floorPrice}
          />
        </>
      );
  }
};

History.propTypes = propTypes;
History.defaultProps = defaultProps;

export default History;
